<template>
    <div>
        <v-row no-gutters class="ma-4">
            <v-col cols="12">
                <v-btn v-if="selected_payments.length" x-small @click="get_receipt_address" depressed color="blue float-right" class="mr-1">
                    <v-icon x-small left>mdi-download</v-icon>
                    Download Receipt
                </v-btn>
                <v-btn x-small @click="buy_credits" depressed color="green float-right" class="mr-1">
                    <v-icon x-small left>mdi-star</v-icon>
                    Buy Credits
                </v-btn>
            </v-col>
            <v-col cols="12">&nbsp;</v-col>
            <v-col cols="12">
                <v-data-table
                    :headers="payment_headers"
                    :items="payment_list"
                    :items-per-page="10"
                    :loading="payments_syncing"
                    class="elevation-1"
                    dense
                    item-key="appDir"
                >
                    <template slot="loading">
                        Loading...
                    </template>
                    <template slot="no-data">
                        No payments made yet
                    </template>
                    <template v-slot:item.icon="{item}">
                        <v-checkbox
                            v-if="item.transaction_id"
                            v-model="selected_payments"
                            :value="item"
                            color="blue"
                            style="width:24px;"
                            class="ma-0 pa-0"
                            hide-details
                            @change="selectDeselectItem(item)"
                        ></v-checkbox>
                    </template>
                    <template v-slot:item.payment_status="{item}">
                        <v-chip x-small :class="`${item.payment_status}`">
                            {{item.payment_status}}
                        </v-chip>
                    </template>
                    <template v-slot:item.by="{item}">
                        <span class="text-capitalize">{{item.by}}</span>
                    </template>
                </v-data-table>
            </v-col>
            <v-col cols="12">&nbsp;</v-col>
            <v-col cols="12">
                <v-btn x-small @click="buy_subscription" depressed color="green float-right" class="mr-1">
                    <v-icon x-small left>mdi-star</v-icon>
                    Purchase Subscription
                </v-btn>
            </v-col>
            <v-col cols="12">&nbsp;</v-col>
            <v-col cols="12">
                <v-data-table
                    :headers="subscriptions_headers"
                    :items="subscriptions_list"
                    :items-per-page="10"
                    :loading="subscriptions_syncing"
                    class="elevation-1"
                    dense
                >
                    <template slot="loading">
                        Loading...
                    </template>
                    <template slot="no-data">
                        No subscriptions found
                    </template>
                    <template v-slot:item.status="{item}">
                        <v-chip v-if="item.status" x-small :class="item.status == 'Active' ? 'success' : ''">
                            {{item.status}}
                        </v-chip>
                    </template>
                    <template v-slot:item.action="{item}">
                        <v-btn depressed fab height="18px" width="18px" @click="show_sub_info(item)"
                            x-small color="success" class="mx-1 pb-1" title="view details">
                            <v-icon x-small>mdi-view-list-outline</v-icon>
                        </v-btn>
                        <v-btn :disabled="item.status != 'Active'" depressed fab height="18px" width="18px" @click="cancel_subscription(item)"
                            x-small color="error" class="mx-1" title="cancel subscription">
                            <v-icon x-small>mdi-close-circle-outline</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-dialog v-model="sub_info_dialog" v-on:click:outside="close_sub_info_dialog($event)" @keydown.esc="close_sub_info_dialog($event)" max-width="720px">
            <v-card width="100%">
                <v-card-title class="pa-0 ma-0">
                    <span class="subtitle-1 font-weight-medium grey darken-3 px-2">Subscription Payments</span>
                    <v-spacer></v-spacer>
                    <v-btn fab dark small text @click="sub_info_dialog=false">
                        <v-icon dark>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="pa-0">
                    <v-container fluid class="pa-0">
                        <v-data-table
                            style="background:#313131"
                            :headers="sub_info_headers"
                            :items="sub_info_list"
                            :items-per-page="10"
                            :loading="sub_info_loading"
                            class="elevation-4"
                            dense
                        >
                            <template slot="loading">
                                Loading...
                            </template>
                            <template slot="no-data">
                                No payments found for subscription
                            </template>
                            <template v-slot:item.status="{item}">
                                <v-chip v-if="item.status" x-small :class="item.status">
                                    {{item.status}}
                                </v-chip>
                            </template>
                        </v-data-table>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="address_dialog"
            v-on:click:outside="address_dialog=false"
            @keydown.esc="address_dialog=false"
            width="500"
        >
            <v-card width="100%">
                <v-card-title class="pa-0 ma-0">
                    <span class="subtitle-1 font-weight-medium grey darken-3 px-2">Enter the address to appear on the receipt</span>
                    <v-spacer></v-spacer>
                    <v-btn fab dark small text @click="address_dialog=false">
                        <v-icon dark>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-container fluid class="pa-0">
                        <v-textarea label="Enter the address to appear on the receipt" ref="receipt_to" v-model="receipt_to" background-color="grey darken-4"></v-textarea>
                        <v-textarea label="Enter notes to appear on the receipt" ref="notes_text" v-model="notes_text" background-color="grey darken-4"></v-textarea>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-btn class="float-right" dark small text @click="address_dialog=false;download_receipt()">
                        Download Receipt
                    </v-btn>
                    <v-btn class="float-right" dark small text @click="address_dialog=false">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "PurchaseHistory",
  data() {
    return {
        mobile_content: false,
        page: 1,
        page_length: 1,
        total_visible: 50,
        gm_logo: "https://gridmarkets-misc.s3.ap-southeast-1.amazonaws.com/receipt_assets/logo_gm_bw.png",
        gm_media_logo: "https://gridmarkets-misc.s3.ap-southeast-1.amazonaws.com/receipt_assets/logo_media.png",
        gm_pharma_logo: "https://gridmarkets-misc.s3.ap-southeast-1.amazonaws.com/receipt_assets/logo_pharma.png",
        current_user: {},
        user_name: "",
        is_pharma_user: false,
        payment_headers: [
            { text: ' ', value: 'icon' },
            { text: 'Date', value: 'payment_date' },
            { text: 'Payment Id', value: 'payment_id' },
            { text: 'Transaction Id', value: 'transaction_id' },
            { text: 'Amount Purchased', value: 'amount_purchased' },
            { text: 'Amount Credited', value: 'amount_credited' },
            { text: 'Promo Code', value: 'promo_code'},
            { text: 'Status', value: 'payment_status'},
            { text: 'Notes', value: 'notes'},
            { text: 'By', value: 'by'}
        ],
        payment_list: [],
        payments_syncing: false,
        subscriptions_syncing: false,
        subscriptions_headers: [
            { text: 'Subscription Id', value: 'id' },
            { text: 'Description', value: 'description' },
            { text: 'Start Date', value: 'start_date' },
            { text: 'End Date', value: 'end_date' },
            { text: 'Status', value: 'status'},
            { text: 'Actions', value: 'action'}
        ],
        subscriptions_list: [],
        sub_info_dialog: false,
        sub_info_loading: false,
        sub_info_headers: [
            { text: 'Date', value: 'payment_date', width: '120px' },
            { text: 'Payment Id', value: 'payment_id' },
            { text: 'Amount', value: 'amount', width: '100px', align: 'center' },
            { text: 'Status', value: 'status'},
            { text: 'Notes', value: 'status_message'}
        ],
        sub_info_list: [],
        action_dialog: false,
        action_message: null,
        items_selected: false,
        selected_payments: [],
        address_dialog: false,
        notes_text: "",
        receipt_date: (new Date()).toDateString(),
        receipt_to:"",
        receipt_from: `805-6 Prosperity Millennia Plaza<br/>
        NorthPoint, HongKong<br/>
        finance@GridMarkets.com<br/>
        For: rendering credits purchased`,
    }
  },
  methods: {
      selectDeselectItem: function() {
        console.log(this.selected_payments);
        this.items_selected = Object.keys(this.selected_payments).length ?  true : false;
      },
      _getPayments() {
        axios.get(`https://${this.$buyerAPI}/payments`)
        .then(resp => {
            this.payments_syncing = false;
            let payment_list = resp.data.data;
            if (this.mobile_view){
                let start_index = (this.page - 1) * this.total_visible;
                let end_index = start_index + this.total_visible;
                this.payments = payment_list.slice(start_index, end_index);
                this.page_length = Math.round(Math.ceil(payment_list.length/50));
            }else{
                this.payment_list = payment_list || [];
            }
        })
        .catch(() => {})
      },
      buy_credits: function (){
        window.open(`https://portal.gridmarkets.com/init/buy_credits?email=${this.userLoggedIn.linkedin_email || this.userLoggedIn.email}`);
      },
      _getSubscriptions() {
        this.subscriptions_syncing = true;
        axios.get(`https://${this.$buyerAPI}/subscriptions`)
        .then(resp => {
            this.subscriptions_syncing = false;
            this.subscriptions_list = resp.data.data;
        })
        .catch(error => {
            this.subscriptions_syncing = false;
            if (error.response){
                if (error.response.status == 401){
                    this.$session.destroy();
                    this.$router.push('/login');
                }
            }else{
                if (error.message == "Network Error"){
                    this.$session.destroy();
                    this.$router.push('/login');
                }
            }
        })
      },
      close_sub_info_dialog() {
          this.sub_info_dialog = false;
      },
      show_sub_info(subscription) {
        this.sub_info_list = [];
        this.sub_info_dialog = true;
        this.sub_info_loading = true;
        axios.get(`https://${this.$buyerAPI}/subscriptions/${subscription.id}`)
        .then(resp => {
            this.sub_info_list = resp.data.data.payments || [];
            this.sub_info_loading = false;
        })
        .catch(error => {
            this.sub_info_loading = false;
            if (error.response){
                if (error.response.status == 401){
                    this.$session.destroy();
                    this.$router.push('/login');
                }
            }else{
                if (error.message == "Network Error"){
                    this.$session.destroy();
                    this.$router.push('/login');
                }
            }
        })
      },
      cancel_subscription(subscription){
        let confirm_cancel = confirm("Are you sure, you want to cancel the subscription?")
        if (!confirm_cancel) {
            return
        }
        
        axios.get(`https://${this.$buyerAPI}/subscriptions/${subscription.id}?action=cancel`)
        .then(() => {
            this.acknowledge_action("Cancelling subscription");
            this._getSubscriptions();
        })
        .catch(error => {
            if (error.response){
                if (error.response.status == 401){
                    this.$session.destroy();
                    this.$router.push('/login');
                }
            }else{
                if (error.message == "Network Error"){
                    this.$session.destroy();
                    this.$router.push('/login');
                }
            }
        })
      },
      buy_subscription: function (){
        window.open(`https://portal.gridmarkets.com/init/subscription_credits?email=${this.current_user.username}`);
      },
      acknowledge_action(msg) {
        this.action_dialog = true;
        this.action_message = msg;
        setTimeout(()=>{
            this.action_dialog = false;
            this.action_message = null;
        }, 2000)
      },
      get_receipt_address: function (){
        this.address_dialog = true;
      },
      download_receipt: function (){
        var data_html = ``;
        var payment_total = 0;
        this.selected_payments.forEach(payment => {
            payment_total += payment.amount_purchased;
            data_html += `<tr>
                <td align="center">${payment.payment_date.replace("T", " ")}</td>
                <td align="center">${payment.transaction_id}</td>
                <td align="center">${payment.amount_purchased.toFixed(2)}</td>
            </tr>`
        });

        data_html += `<tr>
                <td colspan="3" style="text-align:left">
                    <b>Notes :</b> ${this.notes_text}
                </td>
            </tr>`

        data_html += `<tr>
                <td align="center"><b>Total</b></td>
                <td align="center">&nbsp;</td>
                <td align="center"><b>Total $USD ${payment_total.toFixed(2)}</b></td>
            </tr>`

        var css_html = `<style>
            html {
                font-family: sans-serif;
            }

            table {
                margin-bottom:40px !important;
            }

            table.receipt_table tr:last-child > td{
                background-color: #000;
                color: #fff;
            }

            th {
                color: #fff
            }

            th, td {
                vertical-align: top;
                border: 1px solid black;
                text-align: center;
                padding: 5px;
                margin: 0;
            }
            
            tr:nth-child(even) {
                background-color: #ededed;
            }
        </style>
        `

        var receipt_html = `<div>
            
            <table cellspacing=0 width="100%" style="margin:auto;margin-bottom:0px !important;border:none">
                <tbody>
                    <tr>
                        <td width="50%" style="text-align:left;font-size:18px;border:none">Receipt</td>
                        <td width="50%" style="text-align:right;font-size:18px;border:none">${this.receipt_date}</td>
                    </tr>
                </tbody>
            </table>

            <table cellspacing=0 width="100%" style="margin:auto;border:1px solid #1a1a1a">
                <tbody>
                    <tr>
                        <td width="50%" style="text-align:left;font-size:18px">${this.receipt_from}</td>
                        <td width="50%" style="text-align:left;font-size:18px">
                            <b>Name</b>: ${this.userLoggedIn.name}<br/>
                            <b>Email</b>: ${this.userLoggedIn.linkedin_email || this.userLoggedIn.email}<br/>
                            <b>Address</b>: ${this.$refs.receipt_to.value}
                        </td>
                    </tr>
                </tbody>
            </table>

            <table class="receipt_table" cellspacing=0 width="100%" style="margin:auto;border:1px solid #1a1a1a">
                <thead style="background:#000">
                    <tr>
                        <th>Date</th>
                        <th>Transaction ID</th>
                        <th>$USD</th>
                    </tr>
                </thead>
                <tbody>
                    ${data_html}
                </tbody>
            </table>
        </div>`

        var print_window_html = `<html>
            <head>
                <title>GridMarkets Receipt</title>
                ${css_html}
            </head>
            <body>
                <div style="text-align:center;margin:40px">
                    <div style="display:inline-block;padding:10px;">
                        <img src="${this.is_pharma_user ? this.gm_pharma_logo : this.gm_media_logo}">
                    </div>
                </div>
                ${receipt_html}
                <footer style="position: fixed;bottom:20px; width:100%">
                    <div style="text-align: center">
                        &#169; www.GridMarkets.com
                    </div>
                </footer>
            </body>
        </html>`

        var printWindow = window.open('GridMarkets Receipt');
        printWindow.document.write(print_window_html);
      }
  },
  computed : {
    userLoggedIn : function() { 
        return this.$store.getters.userLoggedIn
    }
  },
  created () {
    console.log(this.userLoggedIn);
    this.payments_syncing = true;
    this.subscriptions_syncing = true;
    this._getPayments();
    this._getSubscriptions();
    if (["xs", "sm"].indexOf(this.$vuetify.breakpoint.name) > -1){
    this.mobile_content = true;
    }
  }
}
</script>
<style scoped>
    .v-chip.Completed{
        background: #1976D2 !important;
    }
    .v-chip.Failed{
        background: #FF5252 !important;
    }
</style>